import * as React from 'react';
import Image from 'next/image';
import styled from 'styled-components';
import defaultAvatarImage from '@images/avatar.png';

const ImageWrap = styled(Image)`
  border-radius: 50%;
  object-fit: cover;
  margin-right: 12px;
`;

interface Props {
  profileImage?: string;
  width?: number;
  height?: number;
}

const ProfileImage = ({
  profileImage,
  width = 52,
  height = 52,
}: Props): React.ReactElement => {
  const imageHandler = (src?: string) => {
    if (!src || !src.startsWith('https')) {
      return defaultAvatarImage;
    }
    return src;
  };

  return (
    <ImageWrap
      data-testid="profile-image"
      className="profile-image"
      src={imageHandler(profileImage)}
      alt=""
      width={width}
      height={height}
      style={{ minWidth: width }}
      unoptimized
      onError={(e) => {
        e.currentTarget.src = '/icons/avatar.png';
      }}
    />
  );
};

export default ProfileImage;
